import {SizeTokenValue} from 'common';
import {ArrowDownIcon, ArrowUpIcon} from 'icons';
import {ButtonVariant, IconButton} from 'Button';

import type {SidebarMenuItemStyles, SidebarMenuItemProps} from 'SidebarMenu/types';

type RightProps = SidebarMenuItemStyles & Pick<SidebarMenuItemProps, 'badge' | 'childs'>;

export const MenuItemArrow: React.FC<RightProps> = ({childs, isSelected}) => {
  if (!childs?.length) {
    return null;
  }

  const Component = isSelected ? ArrowUpIcon : ArrowDownIcon;

  return (
    <IconButton variant={ButtonVariant.InnerInput} size={SizeTokenValue.XXSmall}>
      <Component size={SizeTokenValue.Small} />
    </IconButton>
  );
};
